import React from "react";
import Services from "./Services/Services";
import Plan from "./Plan/Plan";
import Reviews from "./Reviews/Reviews";
import Get from "./Get/Get";
import Pack from "./Pack/Pack";

const Pricing = () => {
  return (
    <>
      <Pack />
      <Services />
      <Plan />
      <Reviews />
      <Get />
    </>
  );
};

export default Pricing;
